const _ = require("lodash");

const fns = {
  funcao1() {},

  funcao2() {},

  funcao3() {},

  funcao4() {},

  meta_conta_first_token(v, vw) {
    if (v === null) return "";
    return (v + "").split(";")[0];
  },

  meta_remove_acentos(txt, charslug) {
    const slug = require("slug");
    return (
      slug(txt, global.config.metadmin.slugchar || charslug || "_") || ""
    ).toLowerCase();
  },

  meta_create_botao_join(
    id,
    row,
    identificador,
    tabelaorig,
    tabeladest,
    colunaorig,
    colunadest,
    nome
  ) {
    //console.log('idrow',id, row)
    if (tabelaorig.indexOf("_v_") != -1)
      tabelaorig = tabelaorig.split("_v_")[0];
    return {
      name: (id, row) =>
        global.fn.meta_translate(nome, null, null, this) +
        (row[`_custom_${identificador}`] > 0
          ? " (" + row[`_custom_${identificador}`] + ")"
          : ""),
      action: (id, row) => {
        this.navigateToModule(tabeladest, {
          joined: tabelaorig,
          joinedid: id,
          joinedfrom: this.myself.module,
          joinedsid: this.myself.sid,
          joinedcolunaorig: colunaorig,
          joinedcolunadest: colunadest
        });
      },
      html: (id, row) => null
    };
  },

  meta_dbdef_get_column(tabela, coluna) {
    let re = global.dbdef[tabela].campos.filter(v => v.cmp_coluna == coluna);
    if (re.length > 0) {
      return re[0];
    } else {
      return null;
    }
  },

  meta_gera_txt_download(filename, text) {
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  },

  async meta_get_lista_lang_pendente(lang, vueobject, server = null) {
    let txtout = "";

    if (server == null) {
      try {
        let pack = global.lang[lang];
        let oks = Object.keys(vueobject.$store.state.pendlang)
          .filter(k => pack[k] === null || pack[k] === undefined)
          .filter(k => k != "" && k.substr(0, 1) != "{")
          .map(k => {
            return `"${k}": "${k}",`;
          });
        txtout = oks.join("\n");
      } catch (err) {}
      global.fn.meta_gera_txt_download(`client_keys_${lang}.txt`, txtout);
    } else {
      //puxa arquivo do server

      let resp = await global.express.call(
        "/action/metadmin/getlangfile/" + lang,
        "get"
      );
      global.fn.meta_gera_txt_download(`server_keys_${lang}.txt`, resp);
    }
  },

  async meta_set_active_lang(lang, vueobject) {
    vueobject.loading = true;
    let resp = await global.express.call(
      "/action/metadmin/setlang/" + lang,
      "get"
    );
    vueobject.loading = false;
    if (vueobject.profile) vueobject.profile.language = lang;

    vueobject.$store.dispatch("setLang", lang);
    vueobject.langactive = lang;
    window.location.reload();

    console.log("setLang", resp);
  },
  T(key = "", args = [], fn = null, vueobject = null) {
    return global.fn.meta_translate(key, args, fn, vueobject);
  },
  meta_translate(key = "", args = [], fn = null, vueobject = null) {
    if (key == null) return key;
    let lang =
      global.langinuse ||
      (global.config.metadmin && global.config.metadmin.multilang
        ? global.config.metadmin.multilang.def
        : "pt");

    let result = key;
    if (!(global.lang == null || global.lang[lang] == null)) {
      let pack = global.lang[lang];
      if (pack[key] !== null && pack[key] != undefined) {
        result = pack[key];
      } else {
        //nao encontrado no arquivo;
        //armazenar no local storelang
        if (vueobject)
          if (
            !vueobject.$store.state.pendlang[key] &&
            key &&
            key.substr(0, 1) != "{"
          )
            vueobject.$store.dispatch("appendLang", key);
      }
    }

    if (global.config.lang_debug_mode || global.lang_debug_mode) {
      return "{" + key + "}";
    }

    if (fn != null) {
      return fn(result, args);
    }

    if (args && args.length > 0) {
      for (let argi in args) {
        result = result.replace("%" + argi, args[argi]);
      }
    }

    return result;
  },

  meta_get_valores_campo(modulo, campo) {
    let valores = [];
    try {
      let js = require(`@/lib/dbdef/${modulo}.json`);
      valores = js.campos
        .find(c => c.cmp_coluna == campo)
        .cmp_valores.split(",");
    } catch (errorignore) {}
    return valores;
  },

  metadmin_clean_form_extras(obj) {
    let obj2 = _.assignIn({}, obj);
    delete obj2["_extra"];
    return obj2;
  },

  metadmin_map_by_key(array = [], key) {
    let obj = {};
    array.forEach(o => {
      obj[o[key]] = o;
    });
    return obj;
  },

  captureAndDisplayErrorToast(othis, e) {
    if (e.response != null) {
      //erro disparado back-end

      let toast = othis.$toasted.error(e.response.data.error, {
        position: "top-center",
        duration: 5000,
        keepOnHover: true
      });
    } else if (!!e.message) {
      //erro disparado front-end
      let toast = othis.$toasted.error(e.message, {
        position: "top-center",
        duration: 5000,
        keepOnHover: true
      });
    }
  }
};
export default fns;
